import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  listWrapper: {
    maxWidth: theme.breakpoints.values.lg,
    width: '100%',
  },
})
